
namespace Gamification.Gamification {
    export class UtentiProdottiClassiColumns {
        static columnsKey = 'Gamification.UtentiProdottiClassi';
    }
}